import { render, staticRenderFns } from "./VideoInstructionsSummary.vue?vue&type=template&id=6047fba2&scoped=true"
import script from "./VideoInstructionsSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoInstructionsSummary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VideoInstructionsSummary.vue?vue&type=style&index=0&id=6047fba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047fba2",
  null
  
)

export default component.exports